module.exports = __webpack_public_path__ + "hero-shadow.png";